interface RouteLocation {
  pathname: string;
  search: string;
  hash: string;
  state: unknown;
}

export interface ChatNavigationState {
  returnTo: string;
  returnState?: unknown;
}

export const createChatNavigationState = (
  location: RouteLocation,
): ChatNavigationState => ({
  returnTo: `${location.pathname}${location.search}${location.hash}`,
  ...(location.state == null ? {} : { returnState: location.state }),
});

export const resolveChatReturn = (
  state: unknown,
): ChatNavigationState | null => {
  if (!state || typeof state !== 'object') return null;

  const candidate = state as Partial<ChatNavigationState>;
  if (
    typeof candidate.returnTo !== 'string' ||
    !candidate.returnTo.startsWith('/') ||
    candidate.returnTo.startsWith('//')
  ) {
    return null;
  }

  return {
    returnTo: candidate.returnTo,
    ...(candidate.returnState == null ? {} : { returnState: candidate.returnState }),
  };
};
